// extracted by mini-css-extract-plugin
module.exports = {"section":"section__3yVSC","privacy-policy-note":"privacy-policy-note__1EjJR","note":"note__TbDKu","check-box-wrapper":"check-box-wrapper__egodV","link":"link__wyGZq"};